<div class="bottom-footer">
  <div class="bottom-footer-content">
    <div class="bottom-footer-links">
      <a
        href="https://help.payee.tech/hu/"
        target="_blank"
        class="bottom-footer-link"
      >
        {{ "SHARED_FOOTER_SIMPLE.HELP" | translate }}
      </a>
      <span class="footer-separator">|</span>
      <a
        href="https://www.payee.tech/legal/terms-and-conditions"
        target="_blank"
        class="bottom-footer-link"
      >
        {{ "SHARED_FOOTER_SIMPLE.TERMS_AND_CONDITIONS" | translate }}
      </a>
      <span class="footer-separator">|</span>
      <a
        href="https://www.payee.tech/legal/privacy-policy"
        target="_blank"
        class="bottom-footer-link"
      >
        {{ "SHARED_FOOTER_SIMPLE.PRIVACY_POLICY" | translate }}
      </a>
      <span class="footer-separator">|</span>
      <span class="copyright">{{ "SHARED_FOOTER_SIMPLE.COPYRIGHT" | translate: { year: currentYear } }}</span>
    </div>
  </div>
</div>
